<!-- components/FadeTransition.vue -->
<template>
  <transition
    :mode="mode"
    enter-active-class="transition-all duration-200"
    enter-from-class="opacity-0 -translate-y-1"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transition-all duration-200"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 translate-y-1"
  >
    <slot />
  </transition>
</template>

<script>
  export default {
    props: {
      mode: {
        type: String,
        default: 'out-in'
      }
    }
  };
</script>
